import apiUrl from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'changepassword',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      oldpassword: '',
      newpassword: '',
      confirmpassword: '',
      localwarehouseid: '',
      localclientid: '',
      loginuserid: '',
      validpasswordmsg: false,
      loading: false
    }
  },
  computed: {

  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localwarehouseid = userdetail[0].warehouseid;
    this.localclientid = userdetail[0].clientid;
    this.loginuserid = userdetail[0].userid;
  },
  methods: {

    changePassword() {
      if (this.oldpassword == '' || this.newpassword == '' || this.confirmpassword == '') {
        return false;
      } else {
        var userToken = window.localStorage.getItem('userToken')
        var myStr = userToken.replace(/"/g, '');
        this.loading = true;
        this.input = ({
          userid: this.loginuserid,
          newpassword: this.newpassword,
          oldpassword: this.oldpassword,
          appkey: '$Hub&&$Ops@'
        });
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'users/changeuserpassword',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer vKyXQBGQCK'
            }
          })
          .then((response) => {
            this.loading = false;
            if (response.data.code == 200) {
              this.$alertify.success(response.data.message);
              localStorage.removeItem('permissiondata')
              localStorage.removeItem('userdetail')
              localStorage.removeItem('userToken')
              localStorage.removeItem('isLoggedIn')
              this.$router.push('/login')
            } else {
              this.$alertify.error(response.data.error)
            }
          })
          .catch((httpException) => {
            this.loading = false;
            console.error('exception is:::::::::', httpException)
          })
      }

    },
    resetForm() {
      this.oldpassword = '';
      this.newpassword = '';
      this.confirmpassword = '';
      this.$validator.reset();
      this.errors.clear();
    },
    onSubmit: function() {
      var self = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.changePassword();
        } else {
          console.log('errors exist', this.errors)
          return false;
        }
      }).catch(() => {
        console.log('errors exist')
      });
    },

  }
}

Validator.extend('verify_password', {
    getMessage: field => "The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, 1 special character and atleast 8 or more characters",
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
        return strongRegex.test(value);
    }
});



// WEBPACK FOOTER //
// ./src/views/components/changepassword/changepassword.component.js